import { Component } from 'preact';
import { locale } from '../../../utils/i18n';
import { staticPath } from '../../../utils/common';

export default class Refresh extends Component {
  refresh = () => {
    this.props.reloadQR && this.props.reloadQR();
  };

  render() {
    return (
      <div className="ptm-refresh-wrap ptm-pos-r" onClick={this.refresh} data-key="refresh-section">
        <div className="ptm-refresh-inner ptm-centralized">
          <img src={`${staticPath()}/assets/images/refresh.png`} alt="Refresh" />
          <p className="ptm-reload-txt paytm-txt-center">{locale('qr.reload')}</p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/qr/refresh/index.js